module.exports = __webpack_public_path__ + "img/redmail.667fc8b2.svg";